export default function Products() {
  const products = [
    {
      name: 'VPN',
      description: 'Secure your connection with military-grade encryption and lightning-fast servers worldwide',
      icon: 'ri-shield-line',
      gradient: 'from-teal-500 to-cyan-600',
      features: ['Military-grade encryption', 'Global server network', 'Zero-log policy', 'Unlimited bandwidth']
    },
    {
      name: 'Cleaner',
      description: 'Optimize your device performance by removing junk files and managing storage efficiently',
      icon: 'ri-brush-line',
      gradient: 'from-emerald-500 to-teal-600',
      features: ['Smart cleaning', 'Storage optimization', 'Battery saver', 'Privacy protection']
    }
  ];

  return (
    <section id="products" className="py-24 bg-slate-50">
      <div className="max-w-7xl mx-auto px-8">
        <div className="text-center mb-16">
          <h2 className="text-5xl font-bold text-slate-900 mb-4">Our Products</h2>
          <p className="text-xl text-slate-600 max-w-2xl mx-auto">
            Innovative iOS applications designed to enhance your mobile experience
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-3xl mx-auto" data-product-shop>
          {products.map((product, index) => (
            <div 
              key={index}
              className="group relative bg-white rounded-3xl p-8 shadow-sm hover:shadow-2xl transition-all duration-500 cursor-pointer overflow-hidden"
            >
              {/* Background Gradient */}
              <div className={`absolute inset-0 bg-gradient-to-br ${product.gradient} opacity-0 group-hover:opacity-5 transition-opacity duration-500`}></div>
              
              {/* Content */}
              <div className="relative z-10">
                {/* Icon */}
                <div className={`w-20 h-20 rounded-2xl bg-gradient-to-br ${product.gradient} flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-500`}>
                  <i className={`${product.icon} text-4xl text-white`}></i>
                </div>

                {/* Product Name */}
                <h3 className="text-3xl font-bold text-slate-900 mb-4">{product.name}</h3>

                {/* Description */}
                <p className="text-slate-600 leading-relaxed mb-6">
                  {product.description}
                </p>

                {/* Features */}
                <div className="space-y-3">
                  {product.features.map((feature, idx) => (
                    <div key={idx} className="flex items-start gap-3">
                      <div className={`w-5 h-5 rounded-full bg-gradient-to-br ${product.gradient} flex items-center justify-center flex-shrink-0 mt-0.5`}>
                        <i className="ri-check-line text-xs text-white"></i>
                      </div>
                      <span className="text-sm text-slate-700">{feature}</span>
                    </div>
                  ))}
                </div>
              </div>

              {/* Hover Effect Border */}
              <div className={`absolute inset-0 rounded-3xl border-2 border-transparent group-hover:border-gradient-to-br ${product.gradient} opacity-0 group-hover:opacity-100 transition-opacity duration-500`}></div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}